import { toast } from "react-toastify";

const UseToast = () => {
  const successToast = (message) => {
    return toast.success(message);
  };
  const errorToast = (message) => {
    return toast.error(message);
  };
  const warningToast = (message) => {
    return toast.warning(message);
  };

  return {
    successToast,
    errorToast,
    warningToast,
  };
};

export default UseToast;
